import { State, Effect, dispatch, Actions } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'
import qs from 'qs'

const AdState = State({
  initial: {
    list: [],
    details: null,
    fullList: [],
    type: null,
    page: null
  },
  setAdList (state, payload) {
    return {
      ...state,
      list: payload
    }
  },
  setAdDetails (state, payload) {
    return {
      ...state,
      details: payload
    }
  },
  setFullList (state, payload) {
    return {
      ...state,
      fullList: payload.fullList,
      type: payload.type,
      page: payload.page
    }
  }
})

// eslint-disable-next-line
const adInfo = Effect('adInfo', (id) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({id: id})
  return axios.get(`${apiAddress}advertisement/info${urlParams}`).then((res) => {
    return Actions.horseInfo(res.data.horse.key).then((re) => {
      Actions.setAdDetails({...res.data, horse: re})
      return ({...res.data, horse: re})
    })
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const takeAdsByTopicEffect = Effect('takeAdsByTopic', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({type: params.type, page: params.page})
  return axios.get(`${apiAddress}advertisement/list-by-type${urlParams}`).then((res) => {
    Actions.setFullList({fullList: res.data, type: params.type})
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const loadAdsByTopicEffect = Effect('loadAdsByTopic', (params) => {
  return Actions.takeAdsByTopic(params).then((res) => {
    Actions.setFullList({fullList: res.data, type: params.type, page: params.page})
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const listAdsEffect = Effect('listAds', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}advertisement/list`).then((res) => {
    Actions.setAdList(res.data)
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const saveAdEffect = Effect('saveAd', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = qs.stringify(params)
  return axios.post(`${apiAddress}advertisement/add`, urlParams).then((res) => {
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

export default AdState



// WEBPACK FOOTER //
// ./src/states/ad.js